export default "__VITE_ASSET__CaZc12M3__"